(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        if (!window.customElements.get("erk-legal-policies")) {
            class ErkLegalPolicies extends HTMLElement {
                connectedCallback() {
                    this.tabs = Array.from(this.querySelectorAll(".erk-legal-policies__tab"));
                    this.panels = Array.from(this.querySelectorAll(".erk-legal-policies__panel"));
                    this.navToggle = this.querySelector(".erk-legal-policies__nav-toggle");
                    this.navList = this.querySelector(".erk-legal-policies__nav-list");
                    this.navToggleText = this.querySelector(".erk-legal-policies__nav-toggle-text");
                    if (this.tabs.length <= 1) return;
                    this.handleClick = this.handleClick.bind(this);
                    this.handleKeydown = this.handleKeydown.bind(this);
                    this.addEventListener("click", this.handleClick);
                    this.addEventListener("keydown", this.handleKeydown);
                    const activeTab = this.tabs.find((tab => tab.classList.contains("is-active"))) || this.tabs[0];
                    this.setActiveTab(activeTab);
                    this.closeNav();
                }
                disconnectedCallback() {
                    if (!this.handleClick || !this.handleKeydown) return;
                    this.removeEventListener("click", this.handleClick);
                    this.removeEventListener("keydown", this.handleKeydown);
                }
                handleClick(event) {
                    const toggle = event.target.closest(".erk-legal-policies__nav-toggle");
                    if (toggle && this.contains(toggle)) {
                        this.toggleNav();
                        return;
                    }
                    const tab = event.target.closest(".erk-legal-policies__tab");
                    if (!tab || !this.contains(tab)) return;
                    this.setActiveTab(tab);
                    if (window.matchMedia("(max-width: 999px)").matches) {
                        this.closeNav();
                    }
                }
                handleKeydown(event) {
                    const tab = event.target.closest(".erk-legal-policies__tab");
                    if (!tab || !this.contains(tab)) return;
                    const currentIndex = this.tabs.indexOf(tab);
                    let nextIndex = currentIndex;
                    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                        nextIndex = (currentIndex + 1) % this.tabs.length;
                    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
                    } else if (event.key === "Home") {
                        nextIndex = 0;
                    } else if (event.key === "End") {
                        nextIndex = this.tabs.length - 1;
                    } else if (event.key === "Escape" && window.matchMedia("(max-width: 999px)").matches) {
                        this.closeNav();
                        if (this.navToggle) {
                            this.navToggle.focus();
                        }
                        return;
                    } else {
                        return;
                    }
                    event.preventDefault();
                    this.tabs[nextIndex].focus();
                    this.setActiveTab(this.tabs[nextIndex]);
                }
                toggleNav(forceExpanded) {
                    if (!this.navToggle || !this.navList) return;
                    const isExpanded = typeof forceExpanded === "boolean" ? forceExpanded : this.navToggle.getAttribute("aria-expanded") !== "true";
                    this.navToggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
                    this.navList.classList.toggle("is-collapsed", !isExpanded);
                }
                closeNav() {
                    this.toggleNav(false);
                }
                setActiveTab(activeTab) {
                    const activeIndex = Number(activeTab.dataset.index);
                    this.tabs.forEach(((tab, index) => {
                        const isActive = index === activeIndex;
                        tab.classList.toggle("is-active", isActive);
                        tab.setAttribute("aria-selected", isActive ? "true" : "false");
                    }));
                    this.panels.forEach(((panel, index) => {
                        panel.hidden = index !== activeIndex;
                    }));
                    if (this.navToggleText) {
                        this.navToggleText.textContent = activeTab.textContent.trim();
                    }
                }
            }
            window.customElements.define("erk-legal-policies", ErkLegalPolicies);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();